import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stop",
  "use": "stop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"stop\"><rect x=\"2\" y=\"1.98\" width=\"20\" height=\"20\" rx=\"0.5\" ry=\"0.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol